import React, { memo, useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
     EditorState,
     ContentState,
     convertFromHTML,
     convertToRaw,
} from "draft-js";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";

export const UiSelect = () => {
     const templates = [
          { label: "The Shawshank Redemption", year: 1994 },
          { label: "The Godfather", year: 1972 },
          { label: "The Godfather: Part II", year: 1974 },
          { label: "The Dark Knight", year: 2008 },
     ];
     return (
          <Autocomplete
               className="sbt-styled-input__select"
               disablePortal
               id="combo-box-demo"
               options={templates}
               renderInput={(params) => (
                    <TextField {...params} label="Search View Name" />
               )}
          />
     );
};

export const UiEditor = memo((props) => {
     const [editorState, setEditorState] = useState(() =>
          EditorState.createEmpty(),
     );
     const handleEditorChange = (state) => {
          setEditorState(state);
     };

     const { title } = props;

     const [isAutoFilled, setIsAutoFilled] = useState(false);

     useEffect(() => {
          if (props?.value != "" && props?.value && !isAutoFilled) {
               const blocksFromHtml = htmlToDraft(props.value);
               const contentState = ContentState.createFromBlockArray(
                    blocksFromHtml.contentBlocks,
                    blocksFromHtml.entityMap,
               );
               const initialEditorState =
                    EditorState.createWithContent(contentState);
               setEditorState(initialEditorState);
               setIsAutoFilled(true);
          }
     }, [props?.value]);

     return (
          <>
               <h3 className="sbt-styled-input__editor-title">{title}</h3>
               <Editor
                    editorState={editorState}
                    onEditorStateChange={handleEditorChange}
                    wrapperClassName="sbt-styled-input__editor"
                    onChange={() => {
                         let htmlData = draftToHtml(
                              convertToRaw(editorState.getCurrentContent()),
                         );

                         props.setDescValue(htmlData);
                    }}
               />
          </>
     );
});
